// Haptic feedback for key actions. Dynamically imports @capacitor/haptics so the web
// bundle stays lean; no-ops gracefully when unavailable.

async function load() {
    try {
        return await import("@capacitor/haptics");
    } catch {
        return null;
    }
}

export async function hapticSuccess() {
    try {
        const m = await load();
        if (m?.Haptics) await m.Haptics.notification({ type: m.NotificationType.Success });
    } catch { /* ignore */ }
}

export async function hapticError() {
    try {
        const m = await load();
        if (m?.Haptics) await m.Haptics.notification({ type: m.NotificationType.Error });
    } catch { /* ignore */ }
}

export async function hapticTap() {
    try {
        const m = await load();
        if (m?.Haptics) await m.Haptics.impact({ style: m.ImpactStyle.Light });
    } catch { /* ignore */ }
}
